import React, { useEffect, useRef, useState, CSSProperties } from 'react';
import './tag.less';
import { useDispatch, useSelector } from 'react-redux';
import { setTpaDeskSecondaryFilter } from '../../../store/actions/inPatientAction';
import { RootState } from '../../../store';
import { TPA_BANNER_TEXT } from '../../constants/commonConstants';
import { Checkbox, Dropdown, Menu } from 'antd';
import { ReactComponent as SecondaryFilterChevronIconOpen } from '../../../assets/images/svg/SecondaryFilterChevronIconOpen.svg';
import { ReactComponent as SecondaryFilterChevronIconClose } from '../../../assets/images/svg/SecondaryFilterChevronIconClose.svg';
import { toSentenceCase } from '../../../utils/customPipeUtil';
import { isEmpty } from 'lodash';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';

const SecondaryFilters: React.FC<any> = (props: any): any => {
  const {
    filters = {},
    handleSecondaryFilter,
    inPatientCasesDataCount,
  } = props;
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [intialSelectAll, setInitialSelectAll] = useState(true);
  const { tpaNextStatus, tpaDeskSecondaryFilter } = useSelector(
    (state: RootState): any => state?.selectedInPatientDetail || {},
  );
  const dispatch = useDispatch();
  const dropDownRef = useRef<HTMLDivElement>(null);

  useEffect((): void => {
    if (isEmpty(tpaDeskSecondaryFilter)) {
      setInitialSelectAll(true);
    }
  }, [dropdownVisible]);

  const toggleFilter = (key: string): void => {
    setInitialSelectAll(false);
    const updatedFilters = tpaDeskSecondaryFilter?.includes(key)
      ? tpaDeskSecondaryFilter?.filter((item: string): boolean => item !== key)
      : [...tpaDeskSecondaryFilter, key];

    dispatch(setTpaDeskSecondaryFilter(updatedFilters));
    tpaNextStatus === TPA_BANNER_TEXT.DRAFT_PENDING
      ? handleSecondaryFilter(TPA_BANNER_TEXT.DRAFT)
      : handleSecondaryFilter();
      customGTMEvent({
        event: 'Selected TPA Secondary Filters',
        selectedSecondaryBucket: updatedFilters,
      });
  };

  const toggleSelectAll = (): void => {
    customGTMEvent({
      event: 'Select All TPA Secondary Filter',
    });
    if (intialSelectAll) {
      setInitialSelectAll(false);
    }
    if (tpaDeskSecondaryFilter?.length === Object?.keys(filters)?.length) {
      dispatch(setTpaDeskSecondaryFilter([])); // Unselect all
    } else {
      dispatch(setTpaDeskSecondaryFilter(Object?.keys(filters))); // Select all
    }
    tpaNextStatus === TPA_BANNER_TEXT.DRAFT_PENDING
    ? handleSecondaryFilter(TPA_BANNER_TEXT.DRAFT)
    : handleSecondaryFilter();
  };

  const filterMenu = (
    <Menu className="secondaryFilterDropdown">
      <Menu.Item key="select-all" onClick={toggleSelectAll}>
        <div>
          <Checkbox
            className="customCheckBox"
            checked={
              tpaDeskSecondaryFilter.length === Object?.keys(filters)?.length ||
              intialSelectAll
            }
          />
          <span className="secondaryFilterDropdownTitle">
            {`All (${inPatientCasesDataCount?.secondaryClaimsCount})`}
          </span>
        </div>
      </Menu.Item>

      {Object?.entries(filters)?.map(([key, { title, totalCount }]: any): any => (
        <Menu.Item key={key} onClick={(): void => toggleFilter(key)}>
          <div>
            <Checkbox
              className="customCheckBox"
              checked={tpaDeskSecondaryFilter?.includes(key)}
            />
            <span className="secondaryFilterDropdownTitle">{`${toSentenceCase(title)} (${totalCount})`}</span>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="multi-select-filter-container">
      {Object?.entries(filters)?.length > 0 && (
        <div ref={dropDownRef} className="secondaryFilterDropdownZindex">
          <Dropdown
            overlay={filterMenu}
            trigger={['click']}
            visible={dropdownVisible}
            onVisibleChange={setDropdownVisible} // Update state when dropdown is opened/closed
            getPopupContainer={(): any => dropDownRef.current as HTMLElement}
          >
            <div
              className={`filter-item ${
                dropdownVisible
                  ? 'secondaryFilterDropdownOpen'
                  : 'secondaryFilterDropdownClose'
              } `}
            >
              <span className="secondaryFilterTitle ml-0">SELECT</span>
              <span className="secondaryFilterTitleCount">
                {inPatientCasesDataCount?.claimsCount}
              </span>
              {dropdownVisible ? (
                <SecondaryFilterChevronIconOpen />
              ) : (
                <SecondaryFilterChevronIconClose />
              )}
            </div>
          </Dropdown>
        </div>
      )}

      <div className="multi-select-filter">
        <div className="filter-container">
          {Object?.entries(filters)?.map(
            ([
              key,
              { title, totalCount, colorCode, backGroundColor },
            ]: any): any => {
              return (
                <div
                  key={key}
                  className={`filter-item`}
                  style={{
                    borderColor: colorCode,
                    backgroundColor: backGroundColor,
                    color: colorCode,
                  }}
                  onClick={(): void => toggleFilter(key)}
                >
                  <Checkbox
                    className="secondaryFilterCustomCheckBox"
                    style={
                      {
                        '--checkbox-border-color': colorCode, // Dynamic border color
                        color: colorCode, // Tick color
                      } as CSSProperties
                    }
                    checked={tpaDeskSecondaryFilter?.includes(key)}
                  />
                  <span className="filter-title">{title}</span>
                  <span className="filter-count">{totalCount}</span>
                </div>
              );
            },
          )}
        </div>
      </div>
    </div>
  );
};

export default SecondaryFilters;
